export const QUOTED_URL_META_FIELDS = `
    quoted_url_meta {
        author
        date
        description
        lang
        article_url
        article_body
        article_pull_provider
        reddit_comments {
            author
            body
            score
            created_utc
            permalink
        }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
        image
        gallery_images
        gallery {
            type
            image
            image_name
            media {
                public_id
                url
                cdn_url
                name
                displayName
                type
                format
                size
                aspect_ratio
                width
                height
                mime
                duration
                ocrText
                ocrExtracted
            }
            width
            height
            aspect_ratio
            media_url
            media_name
            media_cdn_url
            media_hls_url
            media_duration
            media_has_audio
        }
        image_cdn_url
        image_name
        media_url
        media_type
        media_width
        media_height
        media_duration
        media_has_audio
        media_audio_url
        media_hls_url
        logo
        publisher
        title
        url
        author_image
        author_image_cdn_url
        author_image_public_id
        author_image_name
        author_image_size
        author_image_format
        author_image_aspect_ratio
        author_image_width
        author_image_height
        author_image_original
    }
`;
